import { render, staticRenderFns } from "./RsGeneral.vue?vue&type=template&id=de095cca&scoped=true&"
import script from "./RsGeneral.vue?vue&type=script&lang=js&"
export * from "./RsGeneral.vue?vue&type=script&lang=js&"
import style0 from "./RsGeneral.vue?vue&type=style&index=0&id=de095cca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de095cca",
  null
  
)

export default component.exports